import React, {Component} from 'react';

import {autobind} from 'core-decorators';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {FONTS} from 'Frontend/utils/fonts';
import {clampCss, pxToVw} from 'Frontend/utils/helpers';
import {MEDIA} from 'Frontend/utils/mediaQueries';

/**
 * Tabs
 *
 * @property {*} prop Prop comment.
 *
 * @class Tabs
 * @extends {Component}
 */
class Tabs extends Component {
    static propTypes = {
        active: PropTypes.number.isRequired,
        tabNames: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired
    }

    /**
     * Handles Tab click.
     *
     * @param {Number} index Tab index.
     *
     * @returns {Function} Function for on click.
     * @memberof Tabs
     */
    @autobind
    getHandler(index) {
        const {onClick} = this.props;

        return () => onClick(index);
    }

    /**
     * Renders the Component.
     *
     * @returns {JSX} Component.
     * @memberof Tabs
     */
    render() {
        const {active, tabNames} = this.props;

        return (
            <TabsElement>
                {tabNames.map((name, index) => (
                    <Tab
                        key={name}
                        active={active === index}
                        number={tabNames.length}
                        onClick={this.getHandler(index)}
                    >
                        {name}
                    </Tab>
                ))}
            </TabsElement>
        );
    }
}

export default Tabs;

const TabsElement = styled.div`
    --gap: ${clampCss(8, 't')};
    display: inline-flex;
    margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap));
    width: 66.66%;

    & > * {
        margin-left: var(--gap);
        margin-top: var(--gap);
    }

    ${MEDIA.DESKTOP.UP} {
        --gap: max(8px, ${pxToVw(8, 'd')});
    }
`;

const Tab = styled.div`
    ${FONTS.SEMIBOLD}
    border-bottom: 4px solid ${({active}) => (active ? '#DD8871' : '#C8C8D0')};
    color: ${({active}) => (active ? '#DD8871' : '#2E3542')};
    cursor: pointer;
    flex: 1 1 0px;
    font-size: ${clampCss(12, 't')};
    letter-spacing: ${clampCss(0.5, 't')};
    line-height: ${clampCss(16.8, 't')};
    padding: 0 ${clampCss(43, 't')} ${clampCss(16, 't')} ${clampCss(43, 't')};
    text-align: center;
    transition: border-color 0.3s 0s ease-in-out, color 0.3s 0s ease-in-out;

    ${MEDIA.DESKTOP.UP} {
        ffont-size: max(14px, ${pxToVw(14, 'd')});
        letter-spacing: max(0.5px, ${pxToVw(0.5, 'd')});
        line-height: max(19.6px, ${pxToVw(19.6, 'd')});
        padding: 0 max(43px, ${pxToVw(43, 'd')}) max(16px, ${pxToVw(16, 'd')}) max(43px, ${pxToVw(43, 'd')});
    }
`;